import { BuilderContent, GetContentOptions } from '@builder.io/sdk';

import BaseModel from './BaseModel';
import { Message } from '../types/Message';
import { Locale } from '../helpers/LangHelper';

class MessageModel extends BaseModel {
    constructor() {
        super({ modelName: 'message' });
    }

    getAllMessages = async (locale?: Locale, includeUnpublished = false, includeDraft = false) => {
        const draft = includeDraft ?? 'draft';

        const config: GetContentOptions = {
            options: { includeUnpublished, noTargeting: true },
            query: {
                published: {
                    $ni: ['archived', draft],
                },
            },
        };
        if (locale) {
            config.query.query = {
                $elemMatch: {
                    property: {
                        $eq: 'locale',
                    },
                    value: locale,
                },
            };
        }

        const messages = await this.builder.getAll(this.modelName, config);
        return messages;
    };

    getMessage = async (id: string, includeUnpublished = false) => {
        return this.find({ params: { modelId: id }, includeUnpublished });
    };

    getValidMessage = (messages: BuilderContent[]): Message | undefined => {
        if (!messages) return;
        const message = messages.find((mess) => {
            const startDate = (mess.data?.startDate ? new Date(mess.data.startDate) : new Date(2000, 1, 1)).getTime();
            const endDate = (mess.data?.endDate ? new Date(mess.data.endDate) : new Date(9999, 1, 1)).getTime();
            const readDateStr = localStorage.getItem(mess.id!);

            const isRead = !!readDateStr;
            let isShowAgain = false;
            if (readDateStr) {
                const readDate = new Date(Number.parseInt(readDateStr));

                const today = new Date();
                const diffDays = today.getDate() - readDate.getDate();
                const diffMonths = today.getMonth() - readDate.getMonth();
                const diffYears = today.getFullYear() - readDate.getFullYear();

                if (diffDays === 0 && diffMonths === 0 && diffYears === 0) {
                    isShowAgain = false;
                } else {
                    isShowAgain = diffDays > 0 || diffMonths > 0 || diffYears > 0;
                }
            }

            const now = Date.now();
            const isValid = now > startDate && now < endDate;
            return isValid && (!isRead || isShowAgain);
        });
        if (message && message.data) {
            return { ...(message.data as Message), id: message.id };
        }
        return undefined;
    };
}

export default new MessageModel();
